export default () => ({
  show: false,
  seleted: 0,

  open(details) {
    this.show = true;
    this.seleted = details.index;
    Grebify.noScroll(true);
  },

  close() {
    this.show = false;
    this.seleted = 0;
    Grebify.noScroll(false);
  },
});
